import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap';
import { PlaidService } from '@shared/services';
import { environment } from '@env/environment';
import { PAYMENT_METHOD } from '@shared/constants/property-details';
import { PreOrderService } from '@modules/pre-order/api';
import { MAX_AMOUNT } from '@shared/constants/plaid';

@Component({
  selector: 'app-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss']
})
export class PaymentMethodComponent implements OnInit {
  public onClose: Subject<string>;
  plaidData;
  property;
  username;
  accounts: Array<any> = [];
  isReady: boolean = false;
  preOrderDetails: any;
  paymentMethod: number = 1;
  propertyPreOrderId: number;
  institutionName: string = '';
  isAccountExist: boolean = false;
  isACHDisabled: boolean = true;
  isMethodOpen;
  methods;

  public baseUrl = environment.baseUrl;

  // form
  selected;
  selectedAccount;
  invalidAccount: boolean = false;
  isSubmitted: boolean = false;

  constructor(
    private bsModalRef: BsModalRef,
    private _plaid: PlaidService,
    private _preorder: PreOrderService
  ) {}

  ngOnInit() {
    this.onClose = new Subject();
    this.propertyPreOrderId =
      (this.property && this.property.propertyPartPreOrderId) || 0;
    this.getDetails(this.propertyPreOrderId);
    this.getAccounts();
    if (this.isReady) {
      this.institutionName = this.plaidData.data.institution.name;
      this.accounts = this.plaidData.data.accounts;
      this.selected =
        (this.plaidData.data.accounts &&
          this.plaidData.data.accounts.length &&
          this.plaidData.data.accounts[0].id) ||
        '';
      this.selectedAccount =
        (this.plaidData.data.accounts &&
          this.plaidData.data.accounts.length &&
          this.plaidData.data.accounts[0]) ||
        {};
      this.getAccessToken();
    }
    this.isMethodOpen = false;
    this.methods = [
      { id: PAYMENT_METHOD.ACH_TRANSFER, name: 'ACH Transfer' },
      { id: PAYMENT_METHOD.WIRE_TRANSFER, name: 'Wire Details' }
    ];
  }

  changeMethod(method) {
    this.paymentMethod = method;
  }

  isACHTransfer() {
    return this.paymentMethod === PAYMENT_METHOD.ACH_TRANSFER;
  }

  isWireTransfer() {
    return this.paymentMethod === PAYMENT_METHOD.WIRE_TRANSFER;
  }

  getDetails(preOrderId) {
    if (preOrderId) {
      this._preorder
        .getUserPreOrderDetails(this.username, preOrderId)
        .subscribe(res => {
          this.preOrderDetails = res;
          this.isACHDisabled = res.discountedPreOrderAmount > MAX_AMOUNT;
          this.paymentMethod = (res && res.paymentMethodID) || 1;
          this.checkExistingAccount();
        });
    }
  }

  checkExistingAccount() {
    this._plaid.checkAccount(this.username).subscribe(
      res => {
        if (res) {
          this.isAccountExist = res.exists || false;
          if (this.isAccountExist) {
            this.institutionName = res.accountBankName;
          }
        } else {
          this.isAccountExist = false;
        }
      },
      () => {
        this.isAccountExist = false;
      }
    );
  }

  getAccounts() {
    this._plaid.getAccounts(this.username).subscribe(res => {
      if (!res || !res.accounts) {
        return;
      }
      this.accounts = res.accounts.map(i => {
        i.id = i.account_id;
        return i;
      });
      this.selected = this.accounts[0].account_id;
      this.selectedAccount = this.accounts[0];
      this.isReady = true;
    });
  }

  getAccessToken() {
    const postData = {
      public_token: this.plaidData.public_token,
      bank_name: this.institutionName
    };
    this._plaid.getAccessToken(postData, this.username).subscribe();
  }

  selectAccount(value) {
    this.selectedAccount = this.accounts.find(i => i.id === value);
    this.invalidAccount = false;
  }

  getStripeToken() {
    if (this.isSubmitted) {
      return;
    }
    this.invalidAccount = false;
    this.isSubmitted = true;
    const postData = {
      AccountId: this.selectedAccount.id,
      AccountMask: this.selectedAccount.mask,
      AccountBankName: this.institutionName
    };
    this._plaid.createStripeToken(postData, this.username).subscribe(
      res => {
        if (res && res.stripe_bank_account_token) {
          const bankData = {
            StripeBankToken: res.stripe_bank_account_token,
            Amount: this.amountFilter(
              `${this.preOrderDetails.discountedPreOrderAmount}`
            ),
            PropertyPartPreorderId: this.property.propertyPartPreOrderId
          };
          this.charge(bankData);
        } else {
          this.invalidAccount = true;
          this.isSubmitted = false;
        }
      },
      () => {
        this.invalidAccount = true;
        this.isSubmitted = false;
      }
    );
  }

  charge(data: any) {
    this._plaid.stripeCharge(data, this.username).subscribe(
      () => {
        this.close('done');
        this.isSubmitted = false;
      },
      () => {
        this.invalidAccount = true;
        this.isSubmitted = false;
      }
    );
  }

  amountFilter(value) {
    const period = '.';
    let newValue = '';
    const parts = value.split(period);
    if (parts[1] === undefined) {
      newValue = value.replace(/\D/g, '') + '.00';
    } else {
      const lastPart = parts.slice(-1)[0].replace(/\D/g, '');
      const tempPart =
        lastPart.length < 2 ? `${lastPart}0` : lastPart.substring(0, 2);
      newValue = parts.slice(0, -1).join('') + period + [tempPart];
    }
    return newValue.replace('.', '');
  }

  close(response: string = '') {
    this.onClose.next(response);
    this.bsModalRef.hide();
  }
}
